import { useContext } from 'react'

import { AuthContext } from '@/features/auth/auth-context.tsx'

export function useAuth() {
  return useContext(AuthContext)
}
